<script lang="ts" setup>
import { inject, ref } from "vue";

defineProps<{
  picked?: boolean;
}>();

const mode = inject("colormode", ref("white"));
</script>
<template>
  <div
    class="menu-item"
    :class="{
      active: picked,
      [mode]: true,
    }"
  >
    <slot />
  </div>
</template>
<style scoped>
.menu-item {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  padding: 8px 12px 8px 16px;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.menu-item.white {
  color: #292929;
  background: #fff;
}

.menu-item.white:hover {
  color: #292929;
  background: #D5F1F9;
}

.menu-item.black {
  background: #292929;
  color: #ececec;
}

.menu-item.black:hover {
  background: #494949;
  color: #ffffff;
}
</style>
